// @flow

import { createSelector } from 'reselect';

import interactableFriendGroupsSelector from './interactableFriendGroupsSelector';

/**
 * Retrieves all groups that the given user ID is contained in
 */
function getGroupsForFriend(userId, groups: Array<Group>): Array<Group> {
  return new Set(groups.filter(group => group.members.includes(userId)));
}

const groupsForFriendSelector = createSelector(
  userId => userId,
  (userId, state) => interactableFriendGroupsSelector(state),
  getGroupsForFriend
);

export default groupsForFriendSelector;
